import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import FloatingBtnImg from 'assets/floating-btn.svg'; 
import PublishIcon from '@material-ui/icons/Publish';

interface FloatingButtonProps {
  targetRef: React.RefObject<HTMLDivElement>;
}

const useStyles = makeStyles((theme) => ({
	root: {
		position: 'fixed',
		top: '50%',
		right: 50,
		transform: 'translateY(-50%)',
		zIndex: 9999,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		cursor: 'pointer',
		[theme.breakpoints.down('xs')]: {
			top: '80%',
			right: 7
		},
	},
	button: {
		width: 140, 
		[theme.breakpoints.down('xs')]: {
			width: 60
		},
	},
	upIcon: {
		fontSize: 50,
		marginTop: -10,
		color: 'var(--color-tertiary)',
		[theme.breakpoints.down('xs')]: {
			fontSize: 36,
			marginTop: -5,
		},
	}
}));

const FloatingButton: React.FC<FloatingButtonProps> = ({ targetRef }) => {
	const classes = useStyles();

	const scrollToTarget = () => {
		if (targetRef.current) {
		  const rect = targetRef.current.getBoundingClientRect();
		  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		  const targetPosition = rect.top + scrollTop - window.innerHeight / 2 + rect.height / 2;
		  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
		}
	};

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

	return (
		<div className={classes.root}>
			<img
				src={FloatingBtnImg}
				alt="Go to Section"
				onClick={scrollToTarget}
				className={classes.button}
			/>
			<PublishIcon 
				onClick={scrollToTop} 
				className={classes.upIcon}
			/>
		</div>
	);
};

export default FloatingButton;
